const quotationChat = {
  quotationChatNavLabel: "Sembang Sebut Harga", // translated 
  quotationChatApprovalTitle: "Sembang Sebut Harga", // translated 
  quotationChatAccountNotApprovedTitle: "Akaun Tidak Diluluskan", // translated 
  quotationChatAccountNotApprovedDescription:
    "Akaun anda belum diluluskan lagi. Sila hubungi pengurus akaun anda untuk maklumat lanjut.", // translated 
  quotationChatViewAiChat: "Lihat Sembang A.I.", // translated 

  quotationRequestChatSessions: "Sesi Sembang", // translated 
  quotationRequestChatNoPastSessions: "Tiada sesi lepas", // translated 
  quotationRequestChatNewChat: "Sembang Baharu", // translated 
  quotationRequestChatCloseSidebar: "Tutup bar sisi", // translated 
  quotationRequestChatSessionFallback: "Sesi Sembang", // translated 
  quotationRequestChatDefaultSessionName: "Sesi Sembang Baharu", // translated 
  quotationRequestChatTitle: "Sembang Permintaan Sebut Harga", // translated 
  quotationRequestChatResponseLanguageLabel: "Bahasa respons", // translated 
  quotationRequestChatOpenSidebar: "Buka bar sisi", // translated 
  quotationRequestChatRenameSession: "Namakan semula sesi", // translated 
  quotationRequestChatDeleteSession: "Padam sesi", // translated 
  quotationRequestChatToggleDarkMode: "Togol mod gelap", // translated 
  quotationRequestChatSwitchToLightMode: "Tukar ke mod cahaya", // translated 
  quotationRequestChatSwitchToDarkMode: "Tukar kepada mod gelap", // translated 
  quotationRequestChatEmptyStateHeading: "Mulakan Perbualan Permintaan Sebut Harga Baharu", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Huraikan keperluan perjalanan anda dan saya akan membuat permintaan sebut harga untuk anda.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Taip mesej anda untuk memulakan perbualan... (Shift+Enter untuk baris baharu)", // translated 
  quotationRequestChatMessagePlaceholder: "Taip mesej anda... (Shift+Enter untuk baris baharu)", // translated 
  quotationRequestChatUploadFile: "Muat naik fail", // translated 
  quotationRequestChatUploadAttachment: "Muat naik lampiran", // translated 

  quotationRequestChatStopGenerating: "Berhenti menjana", // translated 
  quotationRequestChatGenerateQuotation: "Jana sebut harga", // translated 
  quotationRequestChatGenerateFinalQuotation: "Jana Sebut Harga Akhir", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Muktamadkan Permintaan Sebut Harga", // translated 
  quotationRequestChatHoldToRecord: "Tahan untuk merakam mesej suara", // translated 
  quotationRequestChatRecordingReleaseToSend: "Rakaman, keluarkan untuk hantar", // translated 
  quotationRequestChatRecording: "Rakaman...", // translated 
  quotationRequestChatSelectSessionFirst: "Sila pilih sesi sembang terlebih dahulu.", // translated 
  quotationRequestChatCancelVoiceRecording: "Batalkan rakaman suara", // translated 
  quotationRequestChatListening: "Mendengar...", // translated 
  quotationRequestChatTranscribing: "Menyalin...", // translated 

  quotationRequestChatFileUploadedSuccess: "Fail berjaya dimuat naik.", // translated 
  quotationRequestChatFailedCreateSession: "Gagal mencipta sesi sembang. Sila cuba lagi.", // translated 
  quotationRequestChatFailedUploadFile: "Gagal memuat naik fail. Sila cuba lagi.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Sila jawab soalan-soalan yang belum selesai sebelum menghantar mesej lain.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Sila jawab soalan-soalan yang belum selesai sebelum memuktamadkan permintaan sebut harga.", // translated 
  quotationRequestChatFavoriteMarked: "Sesi sembang ditanda sebagai kegemaran", // translated 
  quotationRequestChatFavoriteUnmarked: "Sesi sembang dinyahtanda sebagai kegemaran", // translated 
  quotationRequestChatFailedSetFavorite: "Gagal menetapkan kegemaran", // translated 
  quotationRequestChatFailedUnsetFavorite: "Gagal menyahtetapkan kegemaran", // translated 
  quotationRequestChatRenamedSuccess: "Sesi sembang berjaya dinamakan semula.", // translated 
  quotationRequestChatFailedRename: "Gagal menamakan semula sesi sembang. Sila cuba lagi.", // translated 
  quotationRequestChatDeletedSuccess: "Sesi sembang berjaya dipadamkan.", // translated 
  quotationRequestChatFailedDelete: "Gagal memadam sesi sembang. Sila cuba lagi.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Lampiran berjaya dipadamkan.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Gagal memadam lampiran. Sila cuba lagi.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Permintaan sebut harga berjaya dihantar! Permintaan anda sedang diproses.", // translated 
  quotationRequestChatFailedSubmit: "Gagal menghantar permintaan sebut harga", // translated 
  quotationChatPdfDownloadedSuccess: "PDF berjaya dimuat turun!", // translated 
  quotationChatFailedGeneratePdf: "Gagal menjana PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Sila pilih pengguna sub-ejen sebelum menghantar permintaan sebut harga.", // translated 
  quotationRequestChatAppUserLoading:
    "Profil pengguna aplikasi CRM anda masih dimuatkan. Sila cuba lagi sebentar lagi.", // translated 
  quotationRequestChatAppUserMismatch:
    "Profil pengguna aplikasi CRM anda tidak sepadan dengan sesi sembang ini.", // translated 

  quotationRequestChatRenameTitle: "Namakan Sesi Sembang", // translated 
  quotationRequestChatSessionName: "Nama Sesi", // translated 
  quotationRequestChatEnterSessionName: "Masukkan nama sesi", // translated 
  quotationRequestChatSaving: "Menyimpan...", // translated 
  quotationRequestChatSave: "Simpan", // translated 
  quotationRequestChatDeleteTitle: "Padam Sesi Sembang", // translated 
  quotationRequestChatDeleteConfirm: "Adakah anda pasti mahu memadamkan sesi sembang ini?", // translated 
  quotationRequestChatDeleteCannotUndo: "Tindakan ini tidak boleh dibatalkan.", // translated 
  quotationRequestChatDeleting: "Memadam...", // translated 
  quotationRequestChatDelete: "Padam", // translated 

  quotationRequestChatAttachmentsTitle: "Lampiran Sembang Permintaan Sebut Harga", // translated 
  quotationRequestChatLoadingAttachments: "Memuatkan lampiran...", // translated 
  quotationRequestChatNoAttachments: "Tiada lampiran ditemui", // translated 
  quotationRequestChatDeleteAttachment: "Padam lampiran", // translated 
  quotationRequestChatUploadingAttachment: "Memuat naik lampiran...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Sila tunggu sementara fail anda dimuat naik.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Jawab Soalan Tertunda", // translated 
  quotationRequestChatProposeOwnAnswer: "Cadangkan jawapan saya sendiri", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Taip jawapan anda sendiri...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{dijawab}} daripada {{jumlah}} dijawab", // translated 
  quotationRequestChatReadyToSubmit: "Bersedia untuk dihantar", // translated 
  quotationRequestChatSubmitAll: "Hantar semua", // translated 
  quotationRequestChatRespondToOneQuestion: "Balas soalan {{count}}", // translated 
  quotationRequestChatRespondToManyQuestions: "Jawab soalan {{count}}", // translated 

  quotationRequestChatFinalizeTitle: "Muktamadkan Permintaan Sebut Harga", // translated 
  quotationRequestChatLoadingSessionData: "Memuatkan data sesi...", // translated 
  quotationRequestChatErrorLoadingSession: "Ralat memuatkan data sesi. Sila cuba lagi.", // translated 
  quotationRequestChatQuotationTitle: "Tajuk Sebut Harga", // translated 
  quotationRequestChatExtraComments: "Komen Tambahan", // translated 
  quotationRequestChatSubmitting: "Menyerahkan...", // translated 
  quotationRequestChatSubmit: "Hantar", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Menghantar permintaan sebut harga...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Sila tunggu sementara permintaan sebut harga anda dihantar.", // translated 

  quotationRequestChatSelectSubagent: "Pilih Sub-ejen", // translated 
  quotationRequestChatSearchSubagents: "Cari sub-ejen...", // translated 
  quotationRequestChatLoadingSubagents: "Memuatkan sub-ejen...", // translated 
  quotationRequestChatNoSubagentsFound: "Tiada sub-ejen ditemui", // translated 
  quotationRequestChatNoSubagentsAvailable: "Tiada sub-ejen yang tersedia", // translated 
  quotationRequestChatSelectedSubagent: "Dipilih: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Pengguna Sub-ejen", // translated 
  quotationRequestChatSearchUsers: "Cari pengguna...", // translated 
  quotationRequestChatNoUsersFound: "Tiada pengguna ditemui", // translated 
  quotationRequestChatNoUsersAvailable: "Tiada pengguna tersedia", // translated 

  quotationChatDownloadSummaryTitle: "Muat Turun Ringkasan Sebut Harga Anda", // translated 
  quotationChatDownloadSummaryDescription:
    "Isi butiran anda di bawah untuk menghasilkan ringkasan PDF peribadi bagi sebut harga perjalanan anda. PDF tersebut akan merangkumi semua butiran perjalanan, destinasi, maklumat pengangkutan dan jadual perjalanan harian.", // translated 
  quotationChatCustomerTitle: "Tajuk", // translated 
  quotationChatSelectTitle: "Pilih tajuk", // translated 
  quotationChatHonorificMr: "Encik", // translated 
  quotationChatHonorificMrs: "Puan.", // translated 
  quotationChatHonorificMs: "Cik.", // translated 
  quotationChatHonorificDr: "Dr.", // translated 
  quotationChatHonorificProf: "Prof.", // translated 
  quotationChatCustomerPhone: "Telefon", // translated 
  quotationChatCustomerCompany: "Syarikat", // translated 
  quotationChatCustomerMessage: "Mesej", // translated 
  quotationChatCustomerCountry: "Negara", // translated 
  quotationChatGenerating: "Menjana...", // translated 
  quotationChatDownloadPdf: "Muat turun PDF", // translated 

  quotationChatTripSummary: "Ringkasan Perjalanan", // translated 
  quotationChatDownloadAsPdf: "Muat turun sebagai PDF", // translated 
  quotationChatNoTripSummary: "Tiada ringkasan perjalanan tersedia untuk sesi ini.", // translated 

  quotationRequestChatThinking: "Berfikir...", // translated 
  quotationRequestChatSources: "Sumber", // translated 
  quotationRequestChatSearchingWebFor: 'Mencari di web untuk: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Perkhidmatan yang Dilaksanakan oleh Pengendali Pelancongan", // translated 
  quotationRequestChatServicesByCustomer: "Perkhidmatan Dikendalikan oleh Pelanggan", // translated 
  quotationRequestChatReadyNotice:
    "Anda kini boleh menjana sebut harga untuk permintaan ini dengan mengklik butang di sebelah kanan.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Jana sebut harga akhir", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Mungkin anda ingin bertanya:", // translated 
  quotationRequestChatClickToSendSuggestion: "Klik untuk menghantar mesej ini", // translated 

  quotationRequestChatAddToFavorites: "Tambah ke kegemaran", // translated 
  quotationRequestChatRemoveFromFavorites: "Alih keluar daripada kegemaran", // translated 
  quotationRequestChatSubmitted: "Dihantar", // translated 

  quotationRequestChatQuotationRequest: "Permintaan Sebut Harga: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{tajuk}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Status: {{status}}", // translated 

  quotationChatLoading: "Memuatkan...", // translated 
  quotationChatSessionNotFound: "Sesi sembang tidak ditemui untuk sebut harga ini", // translated 
  quotationChatMemberSessionNotFound: "Sesi ahli tidak ditemui untuk akaun anda", // translated 
  quotationChatUnableToConnect: "Tidak dapat menyambung ke sembang", // translated 
  quotationChatConnecting: "Menyambung...", // translated 
  quotationChatTypeYourMessage: "taip mesej anda...", // translated 
  quotationChatConnected: "Bersambung", // translated 
  quotationChatConnectingStatus: "Menyambung...", // translated 
  quotationChatDisconnected: "Terputus sambungan", // translated 
};





export default quotationChat;
